import { useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/constants/images";

const VALUES = ["Amanah dalam mengelola data dan dana jamaah", "Profesional dalam setiap tahap pembinaan", "Ikhlas mendampingi jamaah lahir dan batin"];

export default function About() {
  const navigate = useNavigate();
  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="about-section">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
        <div className="relative">
          <img src={IMAGES.pilgrimsCommunity} alt="Jamaah KBIHU Muhammadiyah Surabaya" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-lg" />
          <div className="absolute -bottom-6 -right-6 hidden rounded-2xl bg-white p-5 shadow-xl sm:block">
            <p className="font-heading text-2xl font-bold text-[#0F6B4F]">10+ Tahun</p>
            <p className="text-xs text-[#64748B]">Mendampingi Jamaah</p>
          </div>
        </div>
        <div>
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Tentang Kami</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Mengenal KBIHU Muhammadiyah Surabaya</h2>
          <p className="mt-5 text-base leading-relaxed text-[#64748B]">
            KBIHU Muhammadiyah Surabaya adalah Kelompok Bimbingan Ibadah Haji dan Umrah yang berdiri untuk membantu jamaah memahami dan menjalankan
            ibadah dengan benar sesuai syariat. Kami hadir dengan pembinaan yang menyeluruh, mulai dari manasik teori dan praktik
            hingga pendampingan langsung sebelum, selama, dan setelah keberangkatan.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#64748B]">
            Visi kami adalah menjadi lembaga bimbingan ibadah yang terpercaya dan humanis, dengan misi memberikan ilmu, bimbingan,
            dan pendampingan tulus kepada setiap jamaah tanpa terkecuali.
          </p>
          <ul className="mt-6 space-y-3">
            {VALUES.map((v) => (
              <li key={v} className="flex items-start gap-3 text-sm text-[#1F2937]">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#0F6B4F]" /> {v}
              </li>
            ))}
          </ul>
          <Button
            data-testid="about-cta-button"
            onClick={() => navigate("/tentang-kami")}
            className="mt-8 gap-2 rounded-full bg-[#0F6B4F] px-6 text-white hover:bg-[#084C3A]"
          >
            Kenali KBIHU Muhammadiyah Surabaya <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
